import type { ReactNode } from 'react';
import { LAYOUT_HEADER, LAYOUT_HEADER_INNER } from './tokens';

interface AppHeaderProps {
  left?: ReactNode;
  center?: ReactNode;
  right?: ReactNode;
  /** Tabs ou barra secundária abaixo do header principal. */
  footer?: ReactNode;
}

export function AppHeader({
  left,
  center,
  right,
  footer,
}: AppHeaderProps) {
  return (
    <header className={`${LAYOUT_HEADER} shrink-0 pt-[env(safe-area-inset-top)]`}>
      <div className={LAYOUT_HEADER_INNER}>
        <div className="flex min-w-0 items-center">{left}</div>
        <div className="flex justify-center">{center}</div>
        <div className="flex items-center justify-end gap-2">{right}</div>
      </div>
      {footer}
    </header>
  );
}
